export default () => ({
    picture: {
        maxWidth: "100%",
    },
    wrapper: {
        display: "flex",
        justifyContent: "center",
    }
});